import React, { useEffect, useState } from "react";
import "./viewUsers.css";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as Email } from "../../Global Icons/Email.svg";
import { ReactComponent as Name } from "../../Global Icons/Name.svg";
import { ReactComponent as Num } from "../../Global Icons/Phone Number.svg";
import { ReactComponent as Status } from "../../Global Icons/Status.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  columnsBookings,
  columnsPayments,
  columnsUsers,
} from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import { Table } from "antd";
import { getBookingsList } from "../../Redux/Actions/bookingActions";
import { listPayments } from "../../Redux/Actions/paymentsActions";
import { viewRefundsList } from "../../Redux/Actions/walletRefundAction";
import { getUser } from "../../Redux/Actions/usersActions";
import { ToFirstCapital, formatBytes } from "../../Utils/helpers";

const ViewUsers = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [foundUser, setFoundUser] = useState({});
  const [selectedTable, setSelectedTable] = useState("post_bookings");

  const { id } = useParams();

  const dispatch = useDispatch();
  const [userSpec, setUserSpec] = useState(null);

  useEffect(() => {
    if (foundUser?.user_specification) {
      try {
        setUserSpec(JSON.parse(foundUser.user_specification));
      } catch (error) {
        setUserSpec(null);
      }
    }
  }, [foundUser]);

  useEffect(() => {
    dispatch(getUser(id));
  }, [id, dispatch]);

  const { singleUser } = useSelector((state) => state.users || {});
  const [showSpecModal, setShowSpecModal] = useState(false);
  const { bookings } = useSelector((state) => state.bookings || {});
  const { payments } = useSelector((state) => state.payments || {});

  useEffect(() => {
    setFoundUser(singleUser?.data);
  }, [singleUser, id]);

  const changeStatusHandler = async (event) => {

    const handleSubmitStatus = async () => {
      const status = event.target.value;
      try {
        const response = await axios.post(
          `${BASE_URL}/user/change-status`,
          {
            id: id,
            status: status,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          return toast.success("Successfully Changed!", dispatch(getUser(id)));
        }
      } catch (error) {
        return toast.error("Error in changing status");
      }
    };
    handleSubmitStatus();
  };

  useEffect(() => {
    const bookingsPayload = {
      page: 1,
      limit: 500,
      is_deleted: false,
      user_id: id,
    };

    switch (selectedTable) {
      case "post_bookings": {
        dispatch(getBookingsList(bookingsPayload));
        break;
      }

      case "payments": {
        dispatch(listPayments(bookingsPayload));
        break;
      }

      case "wallet": {
        dispatch(viewRefundsList(bookingsPayload));
        break;
      }
      default:
        break;
    }
  }, [id, dispatch, selectedTable]);

  return (
    <div className="view_users_overall">
      <div style={{ gridColumn: "4/8", marginRight: "65px" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>
      <div className="back-icon">
        <Link to="/manage_users">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>{ToFirstCapital(foundUser?.name)}</h3>
          <h4>Users/ List/ View</h4>
        </div>
      </div>

      {/* User Profile Card - Redesigned */}
      <div className="user-profile-card">
        <div className="profile-header">
          <div className="profile-image-container">
            <img
              className="profile-image"
              alt="profile"
              src={
                foundUser?.profile_image
                  ? foundUser.profile_image
                  : require("../../Global Icons/AlternateImage.png")
              }
            />
            <div className="status-badge-container">
              <span className={`status-badge ${foundUser?.status === "block" ? "blocked" : "active"}`}>
                {foundUser?.status === "block" ? "Blocked" : "Active"}
              </span>
            </div>
          </div>

          <div className="profile-actions" style={{ display: "flex", flexDirection: "column"}}>
            <button
              onClick={changeStatusHandler}
              className="action-btn block-btn"
              value={"block"}
            >
              <span className="btn-icon">🚫</span>
              Block User
            </button>
            <button
              onClick={changeStatusHandler}
              className="action-btn unblock-btn"
              value={"unblock"}
            >
              <span className="btn-icon">✓</span>
              Unblock User
            </button>
          </div>
        </div>

        <div className="user-info-grid">
          <div className="info-cards">
            <div className="info-labels">User ID</div>
            <div className="info-values">{foundUser?.user_id || "N/A"}</div>
          </div>

          <div className="info-cards">
            <div className="info-icon-wrapper">
              <Name className="info-icons" />
            </div>
            <div className="info-contents">
              <div className="info-labels">Full Name</div>
              <div className="info-values">{foundUser?.name || "No Data"}</div>
            </div>
          </div>

          <div className="info-cards">
            <div className="info-icon-wrapper">
              <Email className="info-icons" />
            </div>
            <div className="info-contents">
              <div className="info-labels">Email</div>
              <div className="info-values">{foundUser?.email || "No Data"}</div>
            </div>
          </div>

          <div className="info-cards">
            <div className="info-icon-wrapper">
              <Num className="info-icons" />
            </div>
            <div className="info-contents">
              <div className="info-labels">Phone Number</div>
              <div className="info-values">{foundUser?.contact_number || "No Data"}</div>
            </div>
          </div>

          <div className="info-cards">
            <div className="info-icon-wrapper">
              <Status className="info-icons" />
            </div>
            <div className="info-contents">
              <div className="info-labels">Account Status</div>
              <div className="info-values">
                {foundUser?.status === "block" ? "Blocked" : "Un-Blocked"}
              </div>
            </div>
          </div>

          {userSpec && (
            <>
              <div className="info-cards specifications-card">
                <div className="spec-header">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span className="spec-icon">📋</span>
                    <h4 className="spec-title">User Specifications</h4>
                    {Object.keys(userSpec).length > 2 && (
                      <button
                        className="view-all-btn"
                        onClick={() => setShowSpecModal(true)}
                        style={{ marginTop: '12px' }}
                      >
                        View All ({Object.keys(userSpec).length})
                      </button>
                    )}
                  </div>
                </div>
                <div className="spec-list">
                  {Object.entries(userSpec)
                    .slice(0, 2)
                    .map(([key, value]) => {
                      const stringValue = String(value);
                      const isBytesField = ["storage", "freestorage", "ram"].includes(key.toLowerCase());
                      const displayValue = isBytesField && !isNaN(value)
                        ? formatBytes(Number(value))
                        : stringValue.length > 50
                          ? `${stringValue.substring(0, 50)}...`
                          : stringValue;

                      return (
                        <div key={key} className="spec-item" style={{ paddingBottom: "9px" }} ref={(el) => el && el.style.setProperty("width", "268%", "important")}>
                          <span className="spec-key" style={{ color: "white" }}>
                            {key.length > 20 ? `${key.substring(0, 20)}...` : key}
                          </span>
                          <span
                            className="spec-value"
                            title={isBytesField ? `${stringValue} (${formatBytes(Number(value))})` : stringValue}
                            style={{
                              maxWidth: '60%',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              display: 'block',
                              color: "#ffffffde"
                            }}
                          >
                            {displayValue}
                          </span>
                        </div>
                      );
                    })}
                </div>
              </div>

              {/* Modal - unchanged, but with formatted bytes */}
              {showSpecModal && (
                <div className="spec-modal-overlay" onClick={() => setShowSpecModal(false)}>
                  <div className="spec-modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="spec-modal-header">
                      <h3>User Specifications ({Object.keys(userSpec).length})</h3>
                      <button className="modal-close-btn" onClick={() => setShowSpecModal(false)}>
                        ×
                      </button>
                    </div>
                    <div className="spec-modal-list">
                      {Object.entries(userSpec).map(([key, value]) => {
                        const stringValue = String(value);
                        const isBytesField = ["storage", "freestorage", "ram"].includes(key.toLowerCase());
                        const displayValue = isBytesField && !isNaN(value)
                          ? formatBytes(Number(value))
                          : stringValue;

                        return (
                          <div key={key} className="spec-modal-item">
                            <span className="spec-modal-key">{key}</span>
                            <span className="spec-modal-value" title={stringValue}>
                              {displayValue}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Data Tables Section - Redesigned */}
      <div className="data-section">
        <div className="tabs-container">
          <button
            className={`tab-button ${selectedTable === "post_bookings" ? "tab-active" : ""}`}
            onClick={() => setSelectedTable("post_bookings")}
          >
            <span className="tab-icon">📅</span>
            Post Bookings
          </button>
          <button
            className={`tab-button ${selectedTable === "refund" ? "tab-active" : ""}`}
            onClick={() => setSelectedTable("refund")}
          >
            <span className="tab-icon">💰</span>
            Refund
          </button>
          <button
            className={`tab-button ${selectedTable === "payments" ? "tab-active" : ""}`}
            onClick={() => setSelectedTable("payments")}
          >
            <span className="tab-icon">💳</span>
            Payments
          </button>
        </div>

        <div className="table-container">
          {selectedTable === "post_bookings" && (
            <Table
              columns={columnsBookings}
              dataSource={
                Array.isArray(bookings?.data?.result)
                  ? bookings.data.result
                  : []
              }
              pagination={{ pageSize: 10 }}
            />
          )}

          {selectedTable === "wallet" && (
            <Table
              columns={columnsUsers}
              pagination={{ pageSize: 10 }}
            />
          )}

          {selectedTable === "payments" && (
            <Table
              columns={columnsPayments}
              dataSource={Array.isArray(payments?.data) ? payments.data : []}
              pagination={{ pageSize: 10 }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewUsers;